import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SiteScrollBlockerService } from './siteScrollBlockerService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SiteScrollBlockerService)
}

export const editor = site
